var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.75 11.044a7.99 7.99 0 0 0 -15.5-.009 8 8 0 0 0 .75 15.965h3a1 1 0 0 0 0-2h-3a6 6 0 0 1 -.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0 1.08 1.08 0 0 0 1.073.854 6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0 -1.414 0l-5 5a1 1 0 0 0 1.414 1.414l3.293-3.293v12.586a1 1 0 0 0 2 0v-12.586z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.48672356551760d03c9871bb5eb61a51.svg";
export { ForwardRef as ReactComponent };